<template>
    <base-custom-settings :form-data="formData" save-message="Het startpunt van de flow is aangepast">
        <template #description>
            <text-heading sub>
                Wanneer zou je graag willen dat deze flow start
            </text-heading>
            <text-description :color="'white'">
                Hieronder vind je het huidige startpunt voor de flow. Je hebt de
                mogelijkheid om het startpunt aan te passen naar je voorkeur.
                Belangrijk om te weten: deze wijziging is alleen van toepassing
                op contacten die vanaf dit moment worden toegevoegd aan de flow.
                Voor bestaande contacten binnen de flow verandert er niets.
            </text-description>
        </template>

        <template #form>
            <flex-container>
                <realworks-taak-type-select-input
                    v-model="formData.taakType"
                />

                <realworks-taak-status-multi-select-input
                    v-model="formData.taakStatuses"
                />

                <timing-input
                    v-model:timingType="formData.timingType as any"
                    v-model:timingQuantity="formData.timingQuantity"
                    v-model:timingUnit="formData.timingUnit as any"
                    :labels="{ before: 'Voor de taak', on: 'Op dag van de taak', after: 'Na de taak' }"
                />

                <realworks-relatiesoort-multi-select-input
                    v-model="formData.relatiesoorten"
                />
            </flex-container>
        </template>
    </base-custom-settings>
</template>

<script setup lang="ts">
    import { FlexContainer, TextDescription, TextHeading } from '@keyvue/one-ui';
    import { reactive } from 'vue';
    import type { Node, Trigger } from '@keyvue/one-api-client';

    import BaseCustomSettings from '@/flow/flow/components/graph/custom-types/CustomSettings.vue';
    import RealworksTaakTypeSelectInput from '@/shared/components/common-form/RealworksTaakTypeSelectInput.vue';
    import RealworksTaakStatusMultiSelectInput from '@/shared/components/common-form/RealworksTaakStatusMultiSelectInput.vue';
    import TimingInput from '@/shared/components/common-form/TimingInput.vue';
    import RealworksRelatiesoortMultiSelectInput from '@/shared/components/common-form/RealworksRelatiesoortMultiSelectInput.vue';

    interface NodeOptions {
        taakType: string
        taakStatuses: string[]
        timingType: string
        timingQuantity: number
        timingUnit: string
        relatiesoorten: string[]
    }

    interface Props {
        node: Trigger | Node
    }

    const props = defineProps<Props>();
    const formData = reactive({
        taakType: props.node.options?.taakType ?? '',
        taakStatuses: props.node.options?.taakStatuses ?? [],
        timingType: props.node.options?.timingType ?? null,
        timingQuantity: props.node.options?.timingQuantity ?? 1,
        timingUnit: props.node.options?.timingUnit ?? 'days',
        relatiesoorten: props.node.options?.relatiesoorten ?? [],
    } as NodeOptions);
</script>
